import InnerBox from '@repo/ui/inner-box'
import MultiSelectInput from '@repo/ui/multiselect-input'
import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { getPeriods } from '../../../api/periods/get-periods'
import { StaffApplicationInput } from '../../../lib/types/models/staff-application/staff-application-input'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'

const StaffApplicationFormAvailability = () => {
  const form = useFormContext<StaffApplicationInput>()

  const { data: periods } = useQuery({
    queryKey: ['periods'],
    queryFn: () => getPeriods({ version: 'BASIC' })
  })

  return (
    <InnerBox title="Disponibilités">
      <FormField
        control={form.control}
        name="periods"
        render={({ field }) => (
          <FormItem className="flex-1">
            <FormControl>
              <MultiSelectInput
                {...field}
                searchable
                label="Périodes"
                variant="warning"
                options={
                  periods?.data?.map((period) => ({
                    label: period.name,
                    value: period.id
                  })) || []
                }
                selectedOptions={
                  field.value?.map((id) => ({
                    label: periods?.data?.find((period) => period.id === id)?.name || '',
                    value: id
                  })) || []
                }
              />
            </FormControl>
          </FormItem>
        )}
      />
    </InnerBox>
  )
}

export default StaffApplicationFormAvailability
